export default "__VITE_ASSET__306c2de6__"